<ng-container *ngIf="content">
  <div class="ql-text-element" [innerHTML]="content" *ngIf="!sanitize"></div>
  <div class="ql-text-element" [innerHTML]="content | map: sanitizeHTML: sanitizer" *ngIf="sanitize"></div>
</ng-container>
